import "./select-box.css";
const SelectBox = ({
  onChange,
  name,
  id,
  options = [],
  label = "Select Box",
  selectedVal,
  isDisabled = false
}) => {
  return (
    <div className="select__box">
      <label htmlFor={id}>{label}</label>
      <select name={name} id={id} onChange={onChange} disabled={isDisabled}>
        <option value="" defaultValue>
          Sélectionner ...
        </option>
        {options.map((opt, index) => {
          if (selectedVal === opt) {
            return (
              <option key={`${opt}-${index}`} value={opt} defaultValue>
                {opt}
              </option>
            );
          }
          return (
            <option key={`${opt}-${index}`} value={opt}>
              {opt}
            </option>
          );
        })}
      </select>
    </div>
  );
};
export default SelectBox;
